module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-campany-governance-fe2ec913692217ab51882306564c9cf1.svg";